module.exports = __webpack_public_path__ + "static/outdoor-window-cleaning-edmonton-f99afd08f3e93f9804892211976ce0e6.jpg";